






















































































































































































































































































































































































































// Vendor
import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import moment from 'moment'
import { findKey, pickBy, throttle } from 'lodash'
import { Table, TableColumn, Select, Option, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'

// Types
import { AdminDocNames, CollectionNames, KeyDict } from '@/types'
import { Stream, SourceStream, StreamType, StreamVariant } from '@/types/streams'
import { SystemStatus } from '@/types/ops'
import { SupportLevel, CustomRtmpDestinationType, InvitedCaster, CallTriage } from '@/types/casts'
import { Cast, CastStatus } from '@/types/casts'
import { Team } from '@/types/teams'
import { UserProfile } from '@/types/users'

// Mixins, classes & helpers
import SubscribeCefstats from '@/mixins/SubscribeCefstats'
import SubscribeAllTeams from '@/mixins/SubscribeAllTeams'
import VideoObject from '@/classes/VideoObject'
import helpers from '@/helpers'
import fb from '@/firebase'
import env from '@/env'

// Components
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import TwitterOps from '@/components/TwitterOps'
import BackupOverview from '@/components/BackupOverview'
import InputOutputStatus from '@/components/InputOutputStatus'
import CasterStatus from '@/components/CasterStatus'
import CrewStatus from '@/components/SingleCast/CrewStatus'
import GlobalWarnings from '@/components/GlobalWarnings'
import FinalOutputPlayer from '@/components/FinalOutputPlayer'
import CastSupportBadge from '@/components/CastSupportBadge/CastSupportBadge.vue'
import CastEnvBadge from '@/components/CastEnvBadge/CastEnvBadge.vue'
import CasterArchive from '@/components/CasterArchive/CasterArchive.vue'
import TabDisplay from '@/components/TabDisplay'

// Styling
import './OpsMonitor.scss'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

interface ConvertedCast {
  ngcvpStatus: string | undefined,
  name: string,
  startdate: string,
  enddate: string,
  castid: string,
  castidurl: string,
  teamid: string,
  teamidurl: string,
  team: string,
  eventid: string,
  eventidurl: string,
  event: string,
  feedNames: object,
  k360eventid: number | undefined,
  k360eventidurl: string,
  inputs: object[],
  outputs: object[],
  video_start_time: number | undefined,
  invited_casters: KeyDict<InvitedCaster>,
  crew: object[],
  online_sessions: KeyDict<string[]>,
  source_streams: KeyDict<Partial<SourceStream>>,
  watermark: boolean,
  supportLevel: string,
  finalPreviewStream: string,
  castStatus: string | undefined,
  isCrossContinent: boolean,
  region: string,
  casters: UserProfile[],
  castInfo: {
    start_date: string,
    end_date: string,
    status: CastStatus | string | undefined
  },
  muteStatus: boolean,
  status: CastStatus | string | undefined,
  logzio: string,
  castUrl: string,
  logzioActions: string,
  sentry: string,
  version: string
}

export default mixins(SubscribeCefstats, SubscribeAllTeams).extend({
  name: 'OpsMonitor',
  computed: {
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    canCreateTeam (): boolean {
      return this.$can(AbilityAction.Create, AbilitySubject.Team)
    },
    teamStreams (): KeyDict<Stream> {
      return this.$store.direct.state.team.streams
    },
    opsmonitorcasts (): KeyDict<Cast> {
      return this.$store.direct.state.opsmonitor.opsmonitorcasts
    },
    pendingSupportRequests (): Cast[] {
      return this.$store.direct.state.opsmonitor.pendingSupportRequests
    },
    streams (): KeyDict<Stream> {
      return this.$store.direct.state.opsmonitor.streams
    },
    users (): KeyDict<UserProfile> {
      return this.$store.direct.state.opsmonitor.users
    },
    userProfile (): UserProfile | null {
      return this.$store.direct.getters.user.userProfile
    },
    teamCheck (): boolean {
      return !!this.$store.direct.state.user.teamCheck
    },
    allTeams (): Team[] {
      return this.$store.direct.state.team.allTeams
    },
    filterValue (): CastStatus | undefined {
      const filter = this.filteroptions.find((f) => f.label === this.filter)
      return filter?.value
    }
  },
  watch: {
    pendingSupportRequests (newVal): void {
      this.setTabCount('pending', newVal.length)
    },
    opsmonitorcasts (): void {
      this.throttledUpdateConvertedCast()
    },
    filter (): void {
      this.init()
    },
    filterstatus (): void {
      this.init()
    },
    teamCheck (newVal): void {
      if (!this.canCreateTeam && newVal) {
      } else {
        this.init()
      }
    }
  },
  mounted (): void {
    // inject jira embed script
    const jiraScript = document.createElement('script')
    jiraScript.setAttribute('src', 'https://kiswemobile.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-egccmf/b/24/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-GB&collectorId=bc1613a5')
    document.head.appendChild(jiraScript)

    // @ts-ignore - set jira trigger function
    window.ATL_JQ_PAGE_PROPS = {
	    triggerFunction: (fn) => this.showJiraIssueDialog = fn
    }

    this.updateInterval = window.setInterval(() => this.throttledUpdateConvertedCast(), 5000)
  },
  beforeDestroy (): void {
    clearInterval(this.updateInterval)
    this.cefHeartbeats.forEach((castId) => this.unsubscribeCefHeartbeat(castId))
    this.cleanupSubscriptions()
  },
  created (): void {
    this.init()
    this.setTabCount('pending', this.pendingSupportRequests.length)
  },
  data: () => ({
    tabs: [
      { label: 'Casts', value: 'casts', icon: '' },
      { label: 'Platinum requests', count: 0, value: 'pending', icon: '' },
      { label: 'Social Media Backend', value: 'social', icon: '' }
    ],
    showJiraIssueDialog: () => console.warn('this.showJiraIssueDialog not set'),
    currentTab: 'casts',
    events: {},
    convertedCasts: [] as ConvertedCast[],
    filter: 'in-progress',
    filterstatus: 'all',
    updateInterval: 0,
    status: {},
    expandRowKeys: [] as string[],
    streamsManager: {},
    cefHeartbeats: [] as string[], // array of cast ids
    castAudioActive: '', // contains cast id
    activePreviews: [] as string[],
    videoObjects: [] as VideoObject[],
    statusoptions: [
      { value: 'all', label: 'All' },
      { value: 'red', label: 'Red Only' }
    ],
    filteroptions: [
      { value: CastStatus.Scheduled, label: 'scheduled' },
      { value: CastStatus.InProgress, label: 'in-progress' },
      { value: CastStatus.Archiving, label: 'archiving' },
      { value: CastStatus.Archived, label: 'archived' }
    ],
    subscribed: false
  }),
  methods: {
    async init () {
      if (!this.filterValue) return
      this.cleanupSubscriptions()
      await Promise.all([
        this.$store.direct.dispatch.opsmonitor.subscribePlatinumSupportRequests(),
        this.$store.direct.dispatch.opsmonitor.subscribeOpsMonitorCasts(this.filterValue),
        this.$store.direct.dispatch.opsmonitor.subscribeStreams(),
        this.$store.direct.dispatch.opsmonitor.subscribeUsers()
      ])
      this.subscribed = true
    },
    cleanupSubscriptions () {
      if (!this.filterValue || !this.subscribed) return
      this.$store.direct.dispatch.opsmonitor.unsubscribePlatinumSupportRequests()
      this.$store.direct.dispatch.opsmonitor.unsubscribeOpsMonitorCasts(this.filterValue)
      this.$store.direct.dispatch.opsmonitor.unsubscribeStreams()
      this.$store.direct.dispatch.opsmonitor.unsubscribeUsers()
      this.subscribed = false
    },
    getURL (name: string, params: object): string {
      return helpers.getURL(this.$router, name, params)
    },
    tabChanged (tab: string): void {
      this.currentTab = tab
    },
    setTabCount (name: string, count: number) {
      this.tabs = this.tabs.map((tab) => {
        if (tab.value !== name) return tab
        tab.count = count
        return tab
      })
    },
    expanceChange (row) {
      const id: string = row.castid
      if (this.expandRowKeys.includes(id)) {
        for (let i = 0; i < this.expandRowKeys.length; i++) {
          if (this.expandRowKeys[i] === id) {
            this.expandRowKeys.splice(i, 1)
          }
        }
      } else {
        this.expandRowKeys.push(id)
      }
    },
    addOutputVideo (vid): void {
      if (this.streamsManager.hasOwnProperty(vid.video)) return
      Vue.set(this.streamsManager, vid.video, {})
      this.makeVideoObject(vid.video, vid.variant)
    },
    makeVideoObject (id: string, variant: StreamVariant): void {
      // @ts-ignore // TODO
      const vidObject = new VideoObject({
        id: id,
        streamToPlay: variant,
        udpEnabled: this.userProfile?.udpEnabled ?? false,
        callback: (stream) => Vue.set(this.streamsManager, id, stream),
        restartStream: (stream) => console.log('restartStream', stream),
        killStream: (stream) => {
          try {
            const video = this.streamsManager[stream.id]
            if (video !== undefined) video.stopPlay()
          } catch (e) {}
          this.$delete(this.streamsManager, stream.id)
        }
      })
      this.videoObjects.push(vidObject)
    },
    casterFeedNames (casterId: string, feedMap): string[] {
      // find stream feednames (eg used by Librato Charts)
      // note: a single caster can have multiple streams (eg after reconnecting)
      const matches: string[] = []
      Object.keys(feedMap || {}).forEach((key: string) => {
        if (feedMap[key] === casterId) {
          matches.push(key)
        }
      })
      return matches
    },
    muteStatus (castId: string): boolean {
      return this.castAudioActive !== castId
    },
    setAudioSource (castId: string): void {
      this.castAudioActive = (this.castAudioActive !== castId) ? castId : ''
    },
    openPreview (castId: string): void {
      if (this.isPreviewing(castId)) return
      this.activePreviews.push(castId)
    },
    closePreview (castId: string): void {
      const index = this.activePreviews.indexOf(castId)
      if (index === -1) return
      this.activePreviews.splice(index, 1)
    },
    isPreviewing (castId: string): boolean {
      return this.activePreviews.includes(castId)
    },
    castIsActive (cast: Partial<Cast>): boolean {
      return helpers.isActiveCast(cast)
    },
    throttledUpdateConvertedCast: throttle(function (this: any) {
      this.updateConvertedCast()
    }, 2000),
    updateConvertedCast () {
      const arr: ConvertedCast[] = []
      const eventids: string[] = []

      for (const [castid, cast] of Object.entries(this.opsmonitorcasts)) {
        if (!cast || !castid) continue
        if (!this.status[castid]) this.status[castid] = { cvp: true }

        const teamid = cast.team_id
        const eventid = cast.event_id
        const event = this.events[eventid]
        const k360eventid = cast.k360_event_id
        const k360eventidurl = `https://${env.portal_url}/admin/ops/${cast.k360_event_id}`
        const castidurl = `https://console.firebase.google.com/u/0/project/${env.firebase.projectId}/database/firestore/data~2Fcasts~2F${castid}`
        const teamidurl = `https://console.firebase.google.com/u/0/project/${env.firebase.projectId}/database/firestore/data~2Fteams~2F${teamid}`
        const eventidurl = `https://console.firebase.google.com/u/0/project/${env.firebase.projectId}/database/firestore/data~2Fevents~2F${eventid}`
        this.status[castid].cvp = cast.ngcvp_status === SystemStatus.OK
        let logzio = ''
        let logzioActions = ''
        let sentry = ''

        if (this.castIsActive(cast)) {
          logzio = `https://app.logz.io/#/dashboard/kibana/discover?_a=(columns:!(message),index:'logzioCustomerIndex*',interval:auto,query:(language:lucene,query:'cc_cast:${castid}'),sort:!('@timestamp',desc))&_g=()`
          logzioActions = `https://app.logz.io/#/dashboard/kibana/discover?_a=(columns:!(message,cc_uid),index:'logzioCustomerIndex*',interval:auto,query:(language:lucene,query:'cc_cast:${castid}%20AND%20cc_UIevent:ui.*'),sort:!('@timestamp',desc))&_g=()`
          sentry = `https://sentry.io/organizations/kiswe/issues/?query=is%3Aunresolved%20url%3Ahttps%3A%2F%2Fstudio.kiswe.com%2Fevent%2F${castid}`
        } else {
          // archiving/archived casts
          // logs are within a specified period only
          const startDate = moment(cast.start_date.seconds * 1000).toISOString()
          const endDate = moment(cast.end_date.seconds * 1000).toISOString()
          logzio = `https://app.logz.io/#/dashboard/kibana/discover?_a=(columns:!(message),index:'logzioCustomerIndex*',interval:auto,query:(language:lucene,query:'cc_cast:${castid}'),sort:!('@timestamp',desc))&_g=(refreshInterval:(pause:!t,value:0),`
          logzio += `time:(from:'${startDate}',to:'${endDate}'))&accountIds=14578&switchToAccountId=14578`
          logzioActions = `https://app.logz.io/#/dashboard/kibana/discover?_a=(columns:!(message,cc_uid),index:'logzioCustomerIndex*',interval:auto,query:(language:lucene,query:'cc_cast:${castid}%20AND%20cc_UIevent:ui.*'),sort:!('@timestamp',desc))&_g=(refreshInterval:(pause:!t,value:0),`
          logzioActions += `time:(from:'${startDate}',to:'${endDate}'))&accountIds=14578&switchToAccountId=14578`

          // Sentry
          const timeQuery = `start=${startDate}&end=${endDate}&utc=true`
          sentry = `https://sentry.io/organizations/kiswe/issues/?${timeQuery}&query=is%3Aunresolved%20url%3Ahttps%3A%2F%2Fstudio.kiswe.com%2Fevent%2F${castid}`
        }

        const isValidInvitedCasters = (caster) => {
          // Support pre-v3.8.0 `invited_casters` where the caster was just a boolean instead of an object.
          return caster === true || caster.triage === CallTriage.Accepted && caster.deleted !== true
        }

        const el: ConvertedCast = {
          ngcvpStatus: cast.ngcvp_status,
          name: cast.name,
          version: cast.version ?? 'unknown',
          startdate: cast.start_date,
          enddate: cast.end_date,
          castid: castid,
          castidurl: castidurl,
          teamid: teamid,
          teamidurl: teamidurl,
          team: this.teamName(teamid),
          eventid: eventid,
          eventidurl: eventidurl,
          event: event ? this.events[eventid].name : '',
          feedNames: cast.feedname || {}, // mind the name and casing - a bit error prone don't you think?
          k360eventid: k360eventid,
          k360eventidurl: k360eventidurl,
          inputs: [],
          outputs: [],
          video_start_time: cast.video_start_time,
          invited_casters: pickBy(cast.invited_casters, isValidInvitedCasters),
          crew: [],
          online_sessions: cast.online_sessions,
          source_streams: cast.source_streams,
          watermark: !!cast.watermark,
          supportLevel: cast.supportLevel,
          finalPreviewStream: '',
          castStatus: cast.status,
          isCrossContinent: !!cast.srt,
          region: cast.region,
          // castInfo needed for archive purposes
          casters: this.getCasters(cast.invited_casters),
          castInfo: {
            start_date: cast.start_date,
            end_date: cast.end_date,
            status: cast.status
          },
          muteStatus: false,
          status: undefined,
          logzio,
          logzioActions,
          castUrl: this.getURL('liveEvent', { id: cast.id }),
          sentry,
        }

        if (cast.hasOwnProperty('output_streams')) {
          if (cast.output_streams.hasOwnProperty('rtsplowres')) {
            if (cast.output_streams.rtsplowres.ngcvp_status === SystemStatus.OK) {
              el.finalPreviewStream = cast.output_streams.rtsplowres.stream
            }
          }
        }

        Object.keys(cast.source_streams).forEach(streamId => {
          if (cast.source_streams[streamId].type === StreamType.Broadcast) {
            const stream = this.streams[streamId] ?? {}
            if (!stream.name) {
              // FIXME: Checking teamStreams doesn't make much sense on the ops page which lists casts from all teams.
              //        But `teamStreams` does include `deleted` streams, while `streams` from opsmonitor store only
              //        includes non-deleted streams.
              const userId = stream.user ?? this.teamStreams?.[streamId]?.user
              if (userId !== undefined) {
                stream.name = this.users[userId]?.first_name ?? 'Input Stream'
              } else {
                stream.name = 'Input Stream'
              }
            }
            if (!stream.type) stream.type = StreamType.Broadcast
            stream.ngcvp_status = cast.source_streams[streamId].ngcvp_status
            stream.start_time = cast?.source_streams[streamId].start_time
            if (stream.ngcvp_status !== SystemStatus.OK) {
              this.status[castid].cvp = false
            }

            // find stream feednames (eg used by Librato Charts)
            // can be more than one (eg left right feeds)
            // FIXME this doesn't work for archived casts (missing streamId?), that's why streamFeedNames() method was added for now
            stream.feedNames = [] as string[]
            if (this.streams[streamId]?.leftrightsplit) {
              const matchleft = findKey(cast.feedname || {}, val => val === `${streamId}_rtmpleft` )
              const matchright = findKey(cast.feedname || {}, val => val === `${streamId}_rtmpright` )
              if (matchleft !== undefined) stream.feedNames.push(matchleft)
              if (matchright !== undefined) stream.feedNames.push(matchright)
            } else {
              const match = findKey(cast.feedname || {}, val => val === streamId)
              if (match !== undefined) stream.feedNames.push(match)
            }

            el.inputs.push(stream)
          }
        })

        if (cast?.custom_rtmp_destinations) {
          Object.keys(cast.custom_rtmp_destinations).forEach((streamId) => {
            if (cast?.custom_rtmp_destinations?.[streamId]) {
              const stream = { name: '', srcurl: '', ngcvp_status: '', ...cast.custom_rtmp_destinations[streamId] }
              stream.name = (stream.type === CustomRtmpDestinationType.Stream) ? this.getOutputStreamName(stream) : streamId
              stream.start_time = cast?.custom_rtmp_destinations[streamId].start_time
              stream.type = CustomRtmpDestinationType.Output
              if (cast.output_streams !== undefined && cast.output_streams.hasOwnProperty(streamId)) {
                stream.ngcvp_status = cast.output_streams[streamId].ngcvp_status
              }
              if (stream.ngcvp_status === 'red') {
                this.status[castid].cvp = false
              }
              el.outputs.push(stream)
            }
          })
        }

        const onlinePeople = cast.online_sessions ?? {}
        if (cast.invited_casters !== undefined) {
          //console.log('online people')
          Object.entries(onlinePeople).forEach(([key, value]) => {
            if (value.length === 0) return
            // the boolean needs to go, this is to be backward compatible with 3.7.0
            const caster: InvitedCaster | boolean | undefined = cast.invited_casters[key]
            let isCaster = false
            if (typeof(caster) === 'boolean') isCaster = true
            else if (caster !== undefined) isCaster = caster.deleted !== true
            const teamMember = this.users[key]
            if (!isCaster && teamMember) el.crew.push(teamMember)
          })
        }

        Object.keys(cast.invited_casters).forEach(casterid => {
          if (this.status[castid][casterid] === false) {
            this.status[castid].cvp = false
          }
        })

        if (!(eventid in eventids) && !(eventid in this.events)) {
          eventids.push(eventid)
        }

        if (cast.video_start_time === undefined) {
          el.status = 'booting'
        } else if (this.status[castid].cvp) {
          el.status = 'ok'
        } else {
          el.status = 'error'
        }

        if (this.filterstatus === 'all' || (this.filterstatus === 'red' && el.status === 'error')) {
          arr.push(el)
        }
      }

      if (eventids.length > 0) {
        this.getEvents(eventids)
      }
      this.expandRowKeys = [...this.expandRowKeys]
      this.convertedCasts = arr

      this.updateCefHearbeatListeners()

    },
    updateCefHearbeatListeners (): void {
      const changes = {
        added: [] as string[],
        removed: [] as string[],
        updatedlist: [] as string[]
      }
      // check added casts
      this.convertedCasts.forEach((cast: ConvertedCast) => {
        changes.updatedlist.push(cast.castid)

        const alreadySubscribed = this.cefHeartbeats.includes(cast.castid)
        if (!alreadySubscribed) changes.added.push(cast.castid)
      })
      // check removed casts
      this.cefHeartbeats.forEach(castid => {
        const stillActive = changes.updatedlist.some(id => id === castid)
        if (!stillActive) changes.removed.push(castid)
      })

      const hasChanges = changes.added.length || changes.removed.length
      if (!hasChanges) return

      if (changes.added.length >= 0) {
        changes.added.forEach((castId) => this.subscribeCefHeartbeat(castId))
      }

      if (changes.removed.length >= 0) {
        changes.removed.forEach((castId) => this.unsubscribeCefHeartbeat(castId))
      }

      this.cefHeartbeats = changes.updatedlist
    },
    getCasters (casterKeys): UserProfile[] {
      const casters: UserProfile[] = []
      if (!casterKeys) return casters

      Object.keys(casterKeys).forEach((casterId) => {
        const userProfile = this.users[casterId]
        if (userProfile !== undefined) {
          casters.push(userProfile)
        }
      })

      return casters
    },
    getOutputStreamName (stream): string {
      let name = stream.streamname
      if (!name) return ''
      name = name.charAt(0).toUpperCase() + name.slice(1)
      let existingFound = false
      Object.values(this.teamStreams).forEach((teamstream) => {
        if (teamstream.srcurl === stream.url && teamstream.type === 'output') {
          if (teamstream.deleted === false) {
            name = teamstream.name
            existingFound = true
          } else if (!existingFound && teamstream.name !== undefined) {
            name = teamstream.name
          }
        }
      })
      return name
    },
    formatDate (paramDate: number): string {
      return moment.unix(paramDate).format('M/D/YYYY h:mm a')
    },
    requestDumpState (castId: string, teamId: string) : void {
      const params = { castId: castId, teamId: teamId }
      this.$store.direct.dispatch.events.requestDumpState(params)
    },
    getEvents (eventids: string[]) {
      for (const eventididx in eventids) {
        const eventid = eventids[eventididx]
        if (!(eventid in this.events)) {
          // TODO: Move to opsmonitor store. (I.e. if we even want to keep it. Because it is only used for the event
          //       name, which for any >=3.9.0 events will be the same as the cast's.
          fb.db.collection(CollectionNames.EVENTS).doc(eventid).get().then((eventc) => {
            const event = eventc.data()
            Vue.set(this.events, eventid, event)
          }).catch(error => {
            console.error('getEvents error ', error)
          })
        }
      }
    },
    updateDelay (data): void {
      console.log('TODO ' + data)
    },
    requestCasterRepublish (caster: string, castid: string): void {
      this.$store.dispatch('logs/addLog', { message: 'Request caster ' + caster + ' to republish', level: 'info' })
      const cast = { republishRequested: {}, id: castid }
      cast.republishRequested[caster] = true
      this.$store.dispatch('events/requestCasterRepublish', cast).then(() => {
        this.$store.dispatch('logs/addLog', { message: 'Update cast event succeeded', level: 'info' })
      }).catch(error => {
        console.error('Error requestCasterRepublish', error)
      })
    },
    statusChanged (castid: string, caster: string, status: any): void {
      this.status[castid][caster] = status
    },
    tableRowClassName ({ row }): string {
      if (row.status !== 'error') return ''
      else return 'row-error'
    },
    restartVariantManager (): void {
      this.$confirm(`Are you sure you want to restart the variant manager?`,
        'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
      }).then(() => {
        const data = { restart_variant_manager: true }
        fb.db.collection(CollectionNames.ADMIN).doc(AdminDocNames.CLOUDCAST_MANAGER_DATA).set(data, { merge: true }).then(() => {
          console.log('SUCCESS')
        }).catch((error) => {
          console.error('Error ', error)
        })
      }).catch(() => {
        //
      })
    },
    teamName (teamid: string): string {
      if (!this.allTeams) return ''
      // TODO: allTeams would better be a KeyDict instead of an array.
      return this.allTeams.find(team => team.id === teamid)?.name ?? ''
    },
    approveSupportRequest (castId: string, supportApproved: boolean): void {
      console.log('approveSupportRequest ', castId, supportApproved)
      const level = (supportApproved) ? SupportLevel.Platinum : SupportLevel.Gold
      const update = {
        id: castId,
        pendingPlatinumRequest: false,
        platinumApproved: !!supportApproved,
        supportLevel: level
      }
      this.$store.direct.dispatch.events.updateCast(update)

      if (supportApproved) {
        this.$message({
          type: 'success',
          message: 'Platinum support approved'
        })
      } else {
        this.$message({
          type: 'warning',
          message: 'Platinum denied - Reverting to Gold support'
        })
      }
    },
    // added for archived casts (more reliable via .uid because sometimes missing id?)
    streamFeedNames (streamId: string, stream: Stream, feednames: object): string[] {
      const feedNames: string[] = []
      if (stream?.leftrightsplit) {
        const matchleft = findKey(feednames || {}, (val: string) => val === `${streamId}_rtmpleft` )
        const matchright = findKey(feednames || {}, (val: string) => val === `${streamId}_rtmpright` )
        if (matchleft !== undefined) feedNames.push(matchleft)
        if (matchright !== undefined) feedNames.push(matchright)
      } else {
        const match = findKey(feednames || {}, (val: string) => val === streamId)
        if (match !== undefined) feedNames.push(match)
      }

      return feedNames
    },
    navigate (name: string, params: any, blank: boolean = false) {
      const url = helpers.getURL(this.$router, name, params)
      if (blank) {
        const tab = window.open(url, '_blank')
        tab?.focus()
      } else {
        window.location.href = url
      }
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-select': Select,
    'el-option': Option,
    'el-dropdown': Dropdown,
    'el-dropdown-item': DropdownItem,
    'el-dropdown-menu': DropdownMenu,
    InputOutputStatus,
    LeftSidebarLayout,
    TwitterOps,
    BackupOverview,
    CasterStatus,
    CasterArchive,
    CrewStatus,
    GlobalWarnings,
    FinalOutputPlayer,
    CastSupportBadge,
    CastEnvBadge,
    TabDisplay
  }
})
